var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "form-container" },
        [
          _c(
            "div",
            { staticClass: "filter-view" },
            [
              _c("el-form", { ref: "form", attrs: { inline: true } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "page_filter_item",
                        attrs: { label: "项目更新时间" },
                      },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            placeholder: "选择开始时间",
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.queryParams.beginDateTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "beginDateTime", $$v)
                            },
                            expression: "queryParams.beginDateTime",
                          },
                        }),
                        _vm._v(" 至 "),
                        _c("el-date-picker", {
                          attrs: {
                            "default-time": "23:59:59",
                            placeholder: "选择结束时间",
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.queryParams.endDateTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "endDateTime", $$v)
                            },
                            expression: "queryParams.endDateTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "page_filter_item",
                        attrs: { label: "项目名称" },
                      },
                      [
                        _c("el-input", {
                          staticClass: "project_my_input_search",
                          attrs: {
                            placeholder: "请输入项目名称",
                            type: "text",
                          },
                          model: {
                            value: _vm.queryParams.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "name", $$v)
                            },
                            expression: "queryParams.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "page_filter_item",
                        attrs: { label: "项目状态" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.queryParams.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "status", $$v)
                              },
                              expression: "queryParams.status",
                            },
                          },
                          _vm._l(_vm.projectStatusList, function (status) {
                            return _c("el-option", {
                              key: "status" + status.code,
                              attrs: { label: status.name, value: status.code },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "page_filter_item",
                        attrs: { label: "品牌" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              "collapse-tags": "",
                              multiple: "",
                              clearable: "",
                              placeholder: "全部",
                            },
                            model: {
                              value: _vm.queryParams.brandCodes,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "brandCodes", $$v)
                              },
                              expression: "queryParams.brandCodes",
                            },
                          },
                          _vm._l(_vm.brandList, function (brand) {
                            return _c("el-option", {
                              key: brand.code,
                              attrs: { label: brand.name, value: brand.code },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml-20 page_filter_item",
                        attrs: {
                          round: "",
                          icon: "el-icon-search",
                          type: "primary",
                        },
                        on: { click: _vm.filterProject },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "page_filter_item",
                        attrs: {
                          round: "",
                          plain: "",
                          icon: "el-icon-refresh",
                        },
                        on: { click: _vm.resetSearForm },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-space-between",
                    staticStyle: { width: "88%" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["myProject_create"],
                            expression: "['myProject_create']",
                          },
                        ],
                        attrs: { icon: "el-icon-plus", type: "primary" },
                        on: { click: _vm.creatProject },
                      },
                      [_vm._v(" 创建表单 ")]
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button-group",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type:
                                    _vm.dataShowType == "card"
                                      ? "primary"
                                      : "default",
                                  size: "mini",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dataShowType = "card"
                                  },
                                },
                              },
                              [
                                _c("font-icon", {
                                  staticClass: "fas fa-th-large",
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type:
                                    _vm.dataShowType == "table"
                                      ? "primary"
                                      : "default",
                                  size: "mini",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dataShowType = "table"
                                  },
                                },
                              },
                              [
                                _c("font-icon", {
                                  staticClass: "fas fa-th-list",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm.dataShowType == "card"
            ? _c("form-card-list", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.projectListLoading,
                    expression: "projectListLoading",
                  },
                ],
                attrs: { "project-list": _vm.projectList },
                on: {
                  "update:projectList": function ($event) {
                    _vm.projectList = $event
                  },
                  "update:project-list": function ($event) {
                    _vm.projectList = $event
                  },
                  refresh: _vm.queryProjectPage,
                  copyProject: _vm.copyProject,
                  openPreviewHandle: _vm.openPreviewHandle,
                  editProject: _vm.editProject,
                  addProjectAssistant: _vm.addProjectAssistant,
                },
              })
            : _vm._e(),
          _vm.dataShowType == "table"
            ? _c("my-form-table", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.projectListLoading,
                    expression: "projectListLoading",
                  },
                ],
                attrs: { "project-list": _vm.projectList },
                on: {
                  "update:projectList": function ($event) {
                    _vm.projectList = $event
                  },
                  "update:project-list": function ($event) {
                    _vm.projectList = $event
                  },
                  refresh: _vm.queryProjectPage,
                  copyProject: _vm.copyProject,
                  openPreviewHandle: _vm.openPreviewHandle,
                  editProject: _vm.editProject,
                  addProjectAssistant: _vm.addProjectAssistant,
                },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "project-page-view" },
            [
              _vm.total > 10
                ? _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.queryParams.current,
                      "page-size": _vm.queryParams.size,
                      total: _vm.total,
                      background: "",
                      layout: "total, prev, pager, next",
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.queryParams, "current", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.queryParams, "current", $event)
                      },
                      "update:pageSize": function ($event) {
                        return _vm.$set(_vm.queryParams, "size", $event)
                      },
                      "update:page-size": function ($event) {
                        return _vm.$set(_vm.queryParams, "size", $event)
                      },
                      "current-change": _vm.queryProjectPage,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "create-form-dialog",
          attrs: {
            visible: _vm.projectFormVisible,
            title: _vm.projectDialogTitle[_vm.titleCode],
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.projectFormVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createForm",
              staticClass: "create-project-form",
              attrs: { model: _vm.formData, "label-width": "110px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "name",
                    label: "表单名称",
                    rules: { required: true, message: "名称不能为空" },
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "请输入表单名称",
                    },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "描述信息", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      rows: 3,
                      autocomplete: "off",
                      type: "textarea",
                      placeholder: "请输入描述信息",
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { staticClass: "section-title-item" }, [
                _c(
                  "span",
                  {
                    staticClass: "section-label",
                    attrs: { slot: "label" },
                    slot: "label",
                  },
                  [
                    _vm._v(" 可见权限 "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top-start" },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v(
                              " 1.如果同时选择了品牌和门店，则默认拥有该品牌和门店权限的用户及其他协作者可见该问卷"
                            ),
                            _c("br"),
                            _vm._v(
                              " 2.如果仅选择了品牌或均未选择，则仅创建人及其他协作者可见该问卷 "
                            ),
                          ]
                        ),
                        _c("i", {
                          staticClass: "el-icon-question section-help",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "品牌", prop: "brandCode" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      on: { change: _vm.handleSelectBrand },
                      model: {
                        value: _vm.formData.brandCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "brandCode", $$v)
                        },
                        expression: "formData.brandCode",
                      },
                    },
                    _vm._l(_vm.brandList, function (brand) {
                      return _c("el-option", {
                        key: brand.code,
                        attrs: { label: brand.name, value: brand.code },
                      })
                    }),
                    1
                  ),
                  _vm.brandCodeIsNull
                    ? _c("div", { staticClass: "brand_code_error" }, [
                        _vm._v("请选择品牌"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "门店", prop: "shopCodes" } },
                [
                  _c("treeselect", {
                    attrs: {
                      multiple: true,
                      limit: 1,
                      options: _vm.shopOptions,
                      limitText: _vm.limitText,
                      placeholder: "请选择",
                      noChildrenText: "无数据",
                      normalizer: _vm.normalizer,
                    },
                    on: { close: _vm.handleCloseTree, open: _vm.focus },
                    model: {
                      value: _vm.formData.shopCodes,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "shopCodes", $$v)
                      },
                      expression: "formData.shopCodes",
                    },
                  }),
                ],
                1
              ),
              _vm.showPermissionConfigPanel
                ? _c("permission-config-panel", {
                    attrs: {
                      "show-description": false,
                      "label-width": "110px",
                    },
                    model: {
                      value: _vm.permissionFormData,
                      callback: function ($$v) {
                        _vm.permissionFormData = $$v
                      },
                      expression: "permissionFormData",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "create-form-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      _vm.projectFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.requestLoading.pushFormData,
                  },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewDialogVisible,
            "destroy-on-close": "",
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _c("pre-view", {
            key: _vm.previewKey,
            ref: "preViewRef",
            attrs: { "preview-qrcode": true, formPropKey: _vm.formKey },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.infoDialogVisible,
            "destroy-on-close": "",
            title: "确认",
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.infoDialogVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title:
                "请注意，如果同时选择了品牌和门店，则默认拥有该品牌和门店权限的用户可见该问卷；如果仅选择了品牌或均未选择，则仅创建人可见该问卷，如需分享给其他用户，请添加协作者。",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.infoDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("assistant-dialog", {
        ref: "assistantRef",
        on: { saved: _vm.queryProjectPage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }